import React, { useState, useEffect } from 'react';
import { Form, Input, Select, InputNumber, Row, Col, Button, Checkbox, Tag } from 'antd';
import TextArea from "antd/lib/input/TextArea";
import config from '../../config/form.json';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { orgmode, productSelection, showloader, editactive, inwardPartner, newPartnerList } from '../../store/gloabalState';
import SectionHeading from './section-headings';
import useNotify from '../../utils/useNotify';
import { handleFinish } from '../../utils/onboarding/sole-kyc/handle-finish';
import { getPanDetails } from '../../utils/onboarding/sole-kyc/get-pan-details';
import { getOrgsDetails, putAddress, postAddress, checkIfFieldExist } from '../../services/httpCalls';
import globalVar, { CountryCode, emailRegex, gstRegex, onlyNumericDigitsRegex, phoneRegex, websiteRegex } from '../../config/globalVar';
import { showField, NEW_REFACTOR} from "../../utils/onboarding/onboardingUtils";

const convertXflowPurposeCodes = (data) => {
    return data.map((item) => {
      return item.code;
    })
  }

const SoleKyc = ({ handleChange, orgDetails }) => {

    // initializing form
    const [form] = Form.useForm();

    // config data for sole kyc 
    const configData = config.soleKyc[0];

    // local states
    const [pan, setPan] = useState("")
    const [iseefc, setIsEeffc] = useState(false)
    const [addressIds, setAddressIds] = useState({
        BUSINESS: "",
        REGISTERED: ""
    })
    const [businessDetails, setBusinessDetails] = useState({
        legalName: "",
        gstNumber: "",
        cin: "",
        leiNumber: "",
        dateOfIncorporation: "",
        countryOfIncorporation: "",
        placeOfIncorporation: "",
        companyType: "",
        natureOfBussiness: "",
        premise: "",
        annualTurnOver: "",
        netWorth: "",
        importExportCode: "",
        isListedCompany: "",
        tan: ""
    })
    const [disablePan, setDisablePan] = useState(false)
    const [sameAddress, setSameAddress] = useState(true)
    const [flagAddress, setFlagAddress] = useState(false)
    const [isOptInward, setIsOptInward] = useState(false)
    const [addressThere, setAddressThere] = useState(false)
    const [isGstNotThere, setIsGstNotThere] = useState(false)
    const [website, setWebsite] = useState("")
    const [socialWebsite, setSocialWebsite] = useState("")
    const [isXflowActive, setIsXflowActive] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(0);
    const [oldXflowPurposeCode, setOldXflowPurposeCode] = useState([]);

    // global states
    const partnerState = useRecoilValue(inwardPartner);
    const partnerListState = useRecoilValue(newPartnerList);
    
    // states
    const [selectionValue, setSelectionValue] = useRecoilState(productSelection)

    // updater/setter
    const setShowLoader = useSetRecoilState(showloader)

    // values
    const mode = useRecoilValue(orgmode)
    const isEditActive = useRecoilValue(editactive)


    // constants/binders
    const notify = useNotify();
    const emailRegexRef = emailRegex;
    const websiteRegexRef = websiteRegex;
    const CountryCodeInstance = CountryCode;
    const phoneRegexRef = phoneRegex; 
    const onlyNumericDigitsRegexRef = onlyNumericDigitsRegex;
    const isCompanyTypeDisabled = (mode === 'view' || 
    (orgDetails?.companyType && orgDetails?.xflowAccountCreationStatus === "DRAFT")) 
     ? true : false
     const WEBSITE = "website"
     const SOCIAL_WEBSITE = "socialWebsite"
    const purposeCodeInwardXflowInstance = globalVar.xflowInwardPurposeCodes;

     const updateAddress = async (addressData, orgId, addressId) => {
        await putAddress(addressData, orgId, addressId)
            .then(res => {
                if (res) {
                    notify.success("Address updated !")
                    window.localStorage.setItem("allowCkyc", "true")
                    setFlagAddress(false)
                }
            })
            .catch(err => {
                if (err) {
                    return false
                }
            })
    }
    const addAddress = async (addressData, orgId) => {
        await postAddress(addressData, orgId)
            .then(res => {
                if (res) {
                    notify.success("Address added !")
                    window.localStorage.setItem("allowCkyc", "true")
                    setFlagAddress(false)
                }
            })
            .catch(err => {
                if (err) {
                    return false
                }
            })
    }

     const changeF = values => {
        if (values.panNumber) {
            setPan(values.panNumber)
        }
        localStorage.setItem("allowCkyc", "false")
    }

    const fetchForm = () => {
        let pan = form.getFieldValue("panNumber")
          if (/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(pan)) {
            let panCharAt = pan.charAt(3)
            if (panCharAt?.toLowerCase() === 'p') {
              getPanDetails({
                pan,
                form,
                notify,
                setShowLoader,
                setIsGstNotThere
              })
            } else {
              form.resetFields()
              notify.error("Please do enter valid pan!")
            }
          } else {
            if (pan.length > 9) {
              notify.error("Please do enter valid pan!")
              form.resetFields()
              form.setFieldValue("panNumber", pan)
            }
          }
      }

      const handleWebsite = (e, type) => {
        if(type === WEBSITE)
            setWebsite(e.target.value)
        if(type === SOCIAL_WEBSITE)
            setSocialWebsite(e.target.value)
      }

    useEffect(() => {
        if(orgDetails.companyType === "FREELANCER"){
            if(!orgDetails.doingBusinessAs || orgDetails.doingBusinessAs === null){
                form.setFieldValue("doingBusinessAs", "NA")
            }
            if(!orgDetails.website || orgDetails.website === null){
                form.setFieldValue("website", "NA")
            }
        }
    }, [orgDetails])

    useEffect(() => {
        let orgId = localStorage.getItem("orgId")
        getOrgsDetails(orgId)
            .then(res => {
                if(res?.xflowAccountCreationStatus === "ACTIVATED"){
                    setIsXflowActive(true);
                }
                if(res?.website) {
                    setWebsite(res.website)
                }
                if(res?.socialWebsite) {
                    setSocialWebsite(res.socialWebsite)
                }
                setIsOptInward(res?.isOptInward)
                if (res?.isOptInward && res?.isOptOutward) {
                    setSelectionValue("both")
                } else if (res?.isOptInward && !res?.isOptOutward) {
                    setSelectionValue("inward")
                } else {
                    setSelectionValue("outward")
                }
                form.setFieldsValue({
                    panNumber: res?.panNumber,
                    legalName: res?.name,
                    gstNumber: res?.gstNumber,
                    doingBusinessAs: res.doingBusinessAs,
                    companyType: res.companyType,
                    website: res.website,
                    socialWebsite: res.socialWebsite,
                    productDescription: res?.productDescription,
                    descriptionForOutward: res?.descriptionForOutward,
                    descriptionForInward: res?.descriptionForInward,
                    comapnyEmail: res.orgEmail,
                    selectedInwardBankAccountType:
                        res?.selectedInwardBankAccountType === "EEFC" ? true : false
                })
                if(res?.xflowPurposeCodeList?.length){
                    let pc = convertXflowPurposeCodes(res?.xflowPurposeCodeList)
                    form.setFieldValue('xflowPurposeCode', pc);
                    setOldXflowPurposeCode(pc);
                }
                setIsGstNotThere(res?.gstNumber ? false : true)
                setIsEeffc(res?.selectedInwardBankAccountType === "EEFC" ? true : false)
                setPan(res?.panNumber)
                if (res?.addresses?.length > 0) {
                    res?.addresses?.forEach(item => {
                        if (item.type === "REGISTERED") {
                            form.setFieldsValue({
                                //registered address detail
                                registeredAddress_addressLineOne: item?.addressLineOne,
                                registeredAddress_addressLineTwo: item?.addressLineTwo,
                                registeredAddress_city: item?.city,
                                registeredAddress_country: item?.country,
                                registeredAddress_pinCode: item?.pinCode,
                                registeredAddress_state: item?.state
                            })
                            let addressIds_ = addressIds
                            addressIds_.REGISTERED = item?.id
                            setAddressIds(addressIds_)
                        }
                        setAddressThere(true)
                    }

                    )
                }
            })
            .catch(err => console.log(err))
    }, [])

      // for removing error messages if the other field has been filled
      useEffect(() => {
        if(!socialWebsite && !website) {
          form.setFields([
            {
              name:"socialWebsite",
              errors:['Required!']
            },
            {
              name:"website",
              errors:['Required!']
            }
          ])
        } else {
          form.setFields([
            {
              name:"socialWebsite",
              errors:[]
            },
            {
              name:"website",
              errors:[]
            }
          ])
        }

    },[socialWebsite,website,form])

    const customTagRender = (props) => {
        const { label, value, closable, onClose } = props;
        return (
          <Tag
            key={value}
            closable={oldXflowPurposeCode?.includes(value) ? false : closable}
            onClose={(e) => {
              e.preventDefault();
              onClose();
            }}
            style={{
              display:'flex',
              alignItems:'center',
            }}
          >
            {value}
          </Tag>
        );
      };

  
    // preventing backspace for selected purpose code
    const HandleInputKeyDown = (event) => {
            if (event.key === 'Backspace') {
                    return event.stopPropagation()
              }
         }

    useEffect(() => {
     setForceUpdate(prev => prev + 1);  // Increment the value to trigger re-render
    }, [oldXflowPurposeCode]);
    
    const renderField = (field, index) => {
        const { type, label, name, props, style, tooltip} = field;

        // formatting rules
        field?.rules?.forEach(item => {
            if (item?.pattern) {
              item.pattern = eval(item?.pattern);
            } 
            if (item?.required) {
                item.required = eval(item?.required);
            }
            if (item?.validator) {
                item.validator = eval(item?.validator)
            }
        });

        // conditional rendering
        if(!field?.product?.includes(selectionValue)) return <></>;
        
        switch (type) {
            case 'Form.Item':
                return (
                    <React.Fragment>
                        <Form.Item
                            label={label}
                            name={name}
                            rules={eval(field?.rules)}
                            tooltip={tooltip}
                            labelCol={field?.labelCol}
                            required={eval(field?.required)}
                        >      
                                {field?.children ? renderField(field?.children, 0) : null }
                        </Form.Item>
                        {field?.subFields ? field?.subFields.map((child, childIndex) => renderField(child, childIndex)) : null}
                    </React.Fragment>
                )
            case 'Input':
                return (
                    <Input
                        disabled={eval(props?.disabled)}
                        readOnly={eval(props?.readOnly)}
                        name={field?.name}
                        onKeyUp={eval(props?.onKeyUp)}
                        onChange={(eval(props?.onChange))}
                     />
                );
            case 'TextArea':
                return (
                    <TextArea
                        className={field.className}
                        maxLength={field.maxLength}
                        readOnly={eval(field.readOnly)}
                        disabled={eval(props?.disabled)}
                    />
                )
            case 'Checkbox':
                return (
                    <Checkbox
                        checked={eval(props?.checked)}
                        onChange={eval(props?.onChange)}
                        style={props?.style}
                        disabled={eval(props?.disablePan)}
                    >
                        {props?.label}
                    </Checkbox>
                )
            case 'Select':
                return (
                    <Select
                        onInputKeyDown={eval(props?.onInputKeyDown)}
                        mode={field?.mode}
                        tagRender={eval(props?.customTagRender)}
                        options={eval(field?.options)}
                        readOnly={eval(props?.readOnly)}
                        disabled={eval(props?.disabled)}
                        showSearch={props?.showSearch}
                        allowClear={props?.allowClear}
                        default={field?.default}
                        filterOption={eval(props?.filterOption)}
                        onKeyUp={eval(props?.onKeyUp)}
                        optionFilterProp={props?.optionFilterProp}
                    />
                )
            case 'InputNumber':
                return (
                    <InputNumber
                        style={style}
                        type={props.type}
                        controls={field?.controls}
                        onKeyUp={eval(props?.onKeyUp)}
                        readOnly={eval(props?.readOnly)}
                    />
                )
            case 'SectionHeading':
                return (
                    <SectionHeading
                        style={field?.style}
                        level={field?.level}
                        heading={field?.heading}
                        Col={field?.Col}
                    />
                )
            default:
                return null;
        }
    }    

    return(
        <Form
        {...configData.formConfig}
        form={form}
        onFinish={(values) => {
            handleFinish({
                form,
                notify,
                values,
                iseefc,
                website,
                addAddress,
                addressIds,
                flagAddress,
                isOptInward,
                handleChange,
                addressThere,
                isEditActive,
                setShowLoader,
                updateAddress,
                socialWebsite,
                selectionValue,
                isXflowActive
            })
        }}
        onValuesChange={changeF}
        className={mode === 'view' && 'readOnly'}
        key={forceUpdate}
    >
        <Row gutter={[16,16]}>
        {configData.fields.map((field, index) => { 
        const isGstRequired = field.hasOwnProperty('isGstNotThere') ? isGstNotThere === field?.isGstNotThere : true; 
        const isFreelancerCheck =field.hasOwnProperty('companyFreelancer') ? orgDetails?.companyType === "FREELANCER" ? field.companyFreelancer === true : field.companyFreelancer === false : true;

        const isVisible = showField(field.productList , partnerListState) &&  isFreelancerCheck && isGstRequired;

        const isRefactoredRender = isVisible;

        return isRefactoredRender && (
            <Col key={index} span={field?.Col ? field?.Col : 12}>
                {renderField(field, index)}
            </Col>
            )
        })}
            
        </Row>
        <div className='fixed_btn_wrap'>
            <Button onClick={() => handleChange(1)}>Previous</Button>
            <Button type="primary" style={{ marginLeft: ".5rem" }} htmlType="submit">Next</Button>
        </div>
    </Form>
    )
}

export default SoleKyc;